(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sab-x-blog-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const doc = document;

  /* Temi del blog: senza JS le pillole sono link a /tagged/<tema>; con JS filtrano sul posto (come sab-common.js del prototipo). */
  doc.querySelectorAll('[data-sab-x-tabs]').forEach((root) => {
    if (root.dataset.sabXReady) return;
    root.dataset.sabXReady = '1';
    const tabs = [...root.querySelectorAll('[data-filter]')];
    const items = [...root.querySelectorAll('[data-world-item]')];
    const empty = root.querySelector('[data-tabs-empty]');
    const select = (tab) => {
      tabs.forEach((t) => {
        if (t === tab) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      const world = tab.dataset.filter;
      let shown = 0;
      items.forEach((item) => {
        const match = world === 'all' ? item.dataset.all === '1' : item.dataset.worldItem.split(' ').includes(world);
        item.hidden = !match;
        if (match && item.dataset.worldItem !== 'promo') shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
    };
    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey) return;
        event.preventDefault();
        select(tab);
      });
    });
    root.classList.add('is-enhanced');
  });

  /* Indice dell'articolo: aperto da desktop, voce attiva mentre si legge, si chiude dopo il click da telefono. */
  const desktop = window.matchMedia('(min-width: 64rem)');
  doc.querySelectorAll('[data-sab-x-toc]').forEach((toc) => {
    if (toc.dataset.sabXReady) return;
    toc.dataset.sabXReady = '1';
    const sync = () => { if (desktop.matches) toc.open = true; };
    sync();
    desktop.addEventListener('change', sync);
    toc.addEventListener('toggle', sync);
    const links = [...toc.querySelectorAll('a[href^="#"]')];
    const heads = links.map((a) => doc.getElementById(decodeURIComponent(a.hash.slice(1)))).filter(Boolean);
    const mark = (id) => links.forEach((a) => {
      if (decodeURIComponent(a.hash.slice(1)) === id) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
    });
    if ('IntersectionObserver' in window && heads.length) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) mark(e.target.id); });
      }, { rootMargin: '-80px 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
    }
    links.forEach((a) => a.addEventListener('click', () => { if (!desktop.matches) toc.open = false; }));
  });

  /* Condivisione: copia il link; «Share» nativo solo da telefono (navigator.share). Nessuno script di terzi. */
  doc.querySelectorAll('[data-sab-x-share]').forEach((box) => {
    if (box.dataset.sabXReady) return;
    box.dataset.sabXReady = '1';
    const url = box.dataset.sabXShare;
    const status = box.querySelector('[data-share-status]');
    const say = (text) => { if (status) status.textContent = text; };
    box.querySelector('[data-share-copy]')?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
        say(box.dataset.copied || 'Link copied. Paste it anywhere you like.');
      } catch (err) {
        say(`${box.dataset.copyFallback || 'Copy this link:'} ${url}`);
      }
    });
    const native = box.querySelector('[data-share-native]');
    if (native && navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      native.hidden = false;
      native.addEventListener('click', () => {
        navigator.share({ title: doc.title, url }).catch(() => {});
      });
    }
  });

  /* Modulo [signup] dentro l'articolo: email e consenso controllati qui, poi SAB.mlSubmit (assets/sab-base.js, JSONP come lo
     script ufficiale del Classic). Il grazie compare SOLO con { success: true } di MailerLite; altrimenti l'errore nel campo
     aria-live e il bottone torna attivo. Nessun successo ottimistico. */
  doc.querySelectorAll('[data-sab-x-signup]').forEach((form) => {
    if (form.dataset.sabXReady) return;
    form.dataset.sabXReady = '1';
    const status = form.querySelector('[data-signup-status]');
    const say = (msg) => {
      if (status) status.textContent = msg || '';
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (form.classList.contains('is-busy') || form.classList.contains('is-sent')) return;
      const email = form.querySelector('input[type="email"]');
      const value = email ? email.value.trim() : '';
      const valid = Boolean(value) && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
      if (email) email.setAttribute('aria-invalid', String(!valid));
      if (!valid) {
        say(form.dataset.invalid || 'Please enter a valid email.');
        if (email) email.focus();
        return;
      }
      const agree = form.querySelector('[data-signup-consent]');
      if (agree && !agree.checked) {
        say(form.dataset.consent || 'Please tick the box to get our emails.');
        agree.focus();
        return;
      }
      const send = window.SAB && window.SAB.mlSubmit;
      const fail = form.dataset.error || 'Something went wrong. Please try again.';
      if (typeof send !== 'function') {
        say(fail);
        return;
      }
      email.value = value;
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      form.classList.add('is-busy');
      form.setAttribute('aria-busy', 'true');
      say('');
      send(form, form.getAttribute('action') || '')
        .then((ok) => {
          if (ok) {
            form.classList.add('is-sent');
            say(form.dataset.thanks || 'Almost done! Check your inbox and confirm your email.');
          } else {
            say(fail);
            if (button) button.disabled = false;
          }
        })
        .finally(() => {
          form.classList.remove('is-busy');
          form.removeAttribute('aria-busy');
        });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
